import React from 'react';
import { motion } from 'framer-motion';
import GalleryAdmin from '../components/GalleryAdmin';
import SEO from '../components/SEO';

const AdminPage: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <SEO 
        title="Panel Administracyjny - Aluxim"
        description="Panel administracyjny do zarządzania galerią projektów Aluxim"
        keywords="admin, panel, galeria, zarządzanie"
      />
      
      <GalleryAdmin />
    </motion.div>
  );
};

export default AdminPage;
